import { TypedDocumentNode, gql } from '@apollo/client';
import { useState } from 'react';

import commonEssence from '@sorare/core/src/assets/rewards/common-essence.png';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { CardImg } from '@sorare/core/src/components/card/CardImg';

import { PackOpeningDialog } from 'components/commonCard/BuyPacks/PackOpeningDialog';

import { CardPack_cardPack } from './__generated__/index.graphql';

type Props = { cardPack: CardPack_cardPack; groupColor: string };
export const CardPack = ({ cardPack, groupColor }: Props) => {
  const { pictureUrl, price } = cardPack;
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Vertical>
        {/* todo: add proper alt once we have a name field on CardPack */}
        <CardImg src={pictureUrl} alt="" width={160} />
        <Button
          size="medium"
          color="tertiary"
          onClick={() => {
            setDialogOpen(true);
          }}
        >
          <Horizontal>
            {/* todo: add proper alt once the name of the new currency is known */}
            <img src={commonEssence} alt="" height={18} />
            {price}
          </Horizontal>
        </Button>
      </Vertical>
      {dialogOpen && (
        <PackOpeningDialog
          open
          onClose={() => setDialogOpen(false)}
          cardPack={cardPack}
          groupColor={groupColor}
        />
      )}
    </>
  );
};

CardPack.fragments = {
  cardPack: gql`
    fragment CardPack_cardPack on CardPack {
      slug
      price
      pictureUrl
      ...PackOpeningDialog_cardPack
    }
    ${PackOpeningDialog.fragments.cardPack}
  ` as TypedDocumentNode<CardPack_cardPack>,
};
